<template>
    <div class="mainBody">
        <div class="searchBox">
            <div class="searchGroup">
                <label>邮箱：</label>
                <el-input v-model="search_Obj.f_email" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <el-button type="primary" plain @click.native="doSearch">搜索</el-button>
            <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick"></Btns>
        </div>
        <div class="dataBox">
            <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                <el-table-column prop="year" label="年度" sortable="custom" width="150"></el-table-column>
                <el-table-column prop="email" label="邮箱" sortable="custom"></el-table-column>
                <el-table-column prop="car_id" label="CARID" sortable="custom"></el-table-column>
                <el-table-column prop="add_time" label="生成时间" sortable="custom"></el-table-column>
                <el-table-column label="操作" width="120" align="center">
                    <template slot-scope="scope">
                        <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pageBox">
            <el-pagination background layout="total, prev, pager, next, jumper" :current-page="current" :total="total" @current-change="pageChange"></el-pagination>
        </div>
        <Info
            width="600px"
            :id="model_id"
            title="查看年报"
            :isshow="infoshow"
            @on-close="closeInfoDialog">
        </Info>
    </div>
</template>

<script>
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import listutil from "@/libs/listutil"
import Info from "./info"

export default {
    name: 'carYearList',
    mixins: [listutil],
    components: { Info, Btns, LabBtns},
    data() {
        return {
            m_name: '年报',
            menu_id: 5400,
            list_url: "/api/admin/caryear/list",
            search_Obj: {
                f_email: '',
            },
            del_Obj:{
                url:'/api/admin/caryear/del',
                data:{
                    ids:''
                }
            },
            enu_name: [],
        };
    },
    methods: {}
};
</script>